module.exports = __webpack_public_path__ + "img/category-brand-hover.334b996f.png";